import { UniqueIdentifier } from "@dnd-kit/core";
import type { FlattenedItem, TreeItem, TreeItems } from "../types";

export const buildSortableTree = (
  flattenedItems: FlattenedItem[],
): TreeItems => {
  const root: TreeItem = {
    id: "root",
    children: [],
    name: "root",
    type: "folder",
  };

  const nodes: Record<string, TreeItem> = { [root.id]: root };
  const items = flattenedItems.map((item) => ({ ...item, children: [] }));

  for (const item of items) {
    const { id, children, name, disabled, type } = item;
    const parentId = item.parentId ?? root.id;
    const parent = nodes[parentId] ?? findItem(items, parentId);

    nodes[id] = { id, children, name, disabled, type };
    parent.children.push(item);
  }

  return root.children;
};

const findItem = (items: TreeItem[], itemId: UniqueIdentifier) => {
  return items.find(({ id }) => id === itemId);
};
